<script lang="ts">
    import { events, articles } from "../../store"

    import Sidebar from "../page/Sidebar.svelte"
    import Article from "../page/Article.svelte"
    import Event from "../page/Event.svelte"
    import ContactForm from "../page/ContactForm.svelte"
</script>

<div class="top-article mb-xl">
    <div class="articles">
        {#each $articles || [] as article}
            {#if article.position === "top"}
                <Article article="{article}" />
            {/if}
        {/each}
    </div>
    <div
        class="wave-bottom"
        style="background-image: url('/assets/page/wave_header_bottom.png');"
    ></div>
</div>

<div class="container">
    <div class="row">
        <div class="col-md-10">
            <ContactForm />

            <img
                src="assets/page/notes.svg"
                alt="Svend Walter - Noten"
                class="mt-lg mb-lg"
            />

            <div class="layout layout-vertical layout-gap-md">
                <h3>Veranstaltungen</h3>
                {#each $events || [] as event}
                    {#if event.position === "content"}
                        <Event event="{event}" />
                    {/if}
                {/each}
            </div>
        </div>
        <div class="col-md-2">
            <Sidebar />
        </div>
    </div>
</div>
